// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zapdos_galar: PokeData = {
  "id": 10170,
  "name": "zapdos-galar",
  "height": 16,
  "weight": 582,
  "base_experience": 290,
  "types": [
    PokeType.FIGHTING,
    PokeType.FLYING
  ],
  "api_moves": [
    "peck",
    "drill-peck",
    "counter",
    "agility",
    "light-screen",
    "focus-energy",
    "reversal",
    "detect",
    "ancient-power",
    "rock-smash",
    "brick-break",
    "bulk-up",
    "pluck",
    "close-combat",
    "quick-guard",
    "thunderous-kick"
  ],
  "moves": [
    "peck",
    "ancient-power",
    "rock-smash",
    "bulk-up",
    "close-combat",
    "gust",
    "roost",
    "vacuum-wave",
    "superpower",
    "sky-attack",
    "karate-chop",
    "acrobatics",
    "tailwind"
  ],
  "evolution_chain": {
    "id": 74,
    "item": null,
    "species": [
      {
        "name": "zapdos",
        "order": 177,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 127,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
